import { isOpenAdminCancelPaymentModal } from "@/atoms/order/is-open-admin-cancel-payment-modal";
import { orderDetailState } from "@/atoms/order/order-detail-state";
import { GLOBAL_ERROR } from "@/common/constant/global-error";
import { ButtonColor } from "@/common/enum/button-color";
import { PaymentStatus } from "@/common/enum/payment-status";
import { AdminOrderDetailHeader } from "@/components/header/AdminOrderDetailHeader";
import { PartnerInfoModal } from "@/components/modal/PartnerInfoModal";
import { OrderDetailPageModaPanel } from "@/components/panel/OrderDetailPageModaPanel";
import { AdminOrderDetailOrdererTable } from "@/components/table/admin-order-orderer-table/AdminOrderDetailOrdererTable";
import { AdminOrderPaymentTable } from "@/components/table/admin-order-payment-table/AdminOrderPaymentTable";
import { AdminOrderDetailReceiverTable } from "@/components/table/admin-order-receiver-table/AdminOrderDetailReceiverTable";
import { H5 } from "@/components/typography/H5";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { TableMain } from "@/page/order/AdminOrderDetail/_componant/table/TableMain";
import { orderService } from "@/services/order-service2";
import { Button } from "flowbite-react";
import { SimpleCancelModal } from "./PAVCCancelModal";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { profileState } from "../../../atoms/user/profile-state";
import { Body14Strong } from "@/components/typography/Body14Strong";
import { Body14Regular } from "@/components/typography/Body14Regular";

export default function AdminOrderDetailPage() {
  const profile = useRecoilValue(profileState);
  const [orderDetail, setOrderDetail] = useRecoilState(orderDetailState);
  const [simpleCancelModalOpen, setSimpleCancelModalOpen] = useState(false);
  const setModal = useSetRecoilState(isOpenAdminCancelPaymentModal);
  const { id } = useParams();

  const [isPartnerInfoModalOpen, setIsPartnerInfoModalOpen] = useState(false);
  const openPartnerInfoModal = () => {
    setIsPartnerInfoModalOpen(true);
  };

  const closePartnerInfoModal = () => {
    setIsPartnerInfoModalOpen(false);
  };

  const getOrderDetail = async () => {
    if (!id) {
      return;
    }

    try {
      const response = await orderService.getById(Number(id));
      if (!response.ok) {
        return alert(GLOBAL_ERROR);
      }
      setOrderDetail(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrderDetail();
  }, [id]);

  if (!orderDetail || !profile) {
    return null;
  }

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1392px] h-full items-between justify-start gap-[16px]">
        <AdminOrderDetailHeader orderDetail={orderDetail} />
        <AdminOrderDetailOrdererTable
          orderDetail={orderDetail}
          openPartnerInfoModal={openPartnerInfoModal}
        />

        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">발주 목록</H5>
          </div>
          <TableMain orderDetail={orderDetail} />
        </div>

        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">결제 정보</H5>
          </div>
          <AdminOrderPaymentTable orderDetail={orderDetail} />
        </div>

        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">배송 정보</H5>
          </div>

          <AdminOrderDetailReceiverTable orderDetail={orderDetail} />
        </div>
        <div>
          <Button
            color={
              orderDetail.payment.status === PaymentStatus.CANCELED
                ? ""
                : ButtonColor.RED
            }
            disabled={orderDetail.payment.status === PaymentStatus.CANCELED}
            onClick={() => {
              if (orderDetail.payment.paymentMethod === 'PAVC' || orderDetail.payment.paymentMethod === 'PALT') {
                setSimpleCancelModalOpen(true);
              } else {
                setModal(true);
              }
            }}
          >
            결제 취소하기
          </Button>
        </div>
        {orderDetail.refundInfo && (
          <Body14Strong>
            <div className="h-20 flex-col justify-start items-start gap-1 inline-flex">
              <div className="justify-start items-center gap-1 inline-flex">
                환불받을 은행 :
                <Body14Regular>
                  {JSON.parse(orderDetail.refundInfo).bank}
                </Body14Regular>
              </div>
              <div className="justify-start items-center gap-1 inline-flex">
                환불 계좌번호 :
                <Body14Regular>
                  {JSON.parse(orderDetail.refundInfo).accountNumber}
                </Body14Regular>
              </div>
              <div className="justify-start items-center gap-1 inline-flex">
                환불 계좌 예금주 :
                <Body14Regular>
                  {JSON.parse(orderDetail.refundInfo).accountHolder}
                </Body14Regular>
              </div>
            </div>
          </Body14Strong>
        )}
      </div>
      <OrderDetailPageModaPanel />
      {
        isPartnerInfoModalOpen && (
          <PartnerInfoModal
            closeModal={closePartnerInfoModal}
            userId={orderDetail.ordererId}
          />
        )
      }

      <SimpleCancelModal
        show={simpleCancelModalOpen}
        onClose={() => setSimpleCancelModalOpen(false)}
        orderDetail={orderDetail}
        onSuccess={(updatedOrder) => {
          setOrderDetail(updatedOrder);
          setSimpleCancelModalOpen(false);
        }}
      />
    </PageWrapper >
  );
}
